/*
  Popup de cupom + bolha no canto.

  Memoria (localStorage), tres chaves:
  - inscrito : inscreveu -> nada aparece por 365 dias
  - fechado  : fechou o popup -> nao reabre sozinho por N dias, mas a bolha fica
  - bolha    : fechou a bolha -> ela some por M dias

  Regras:
  - Nao aparece em carrinho, checkout, conta.
  - No editor: abre ao selecionar a secao.
  Reusa o <modal-dialog> do Dawn (foco preso, ESC, clique fora).
*/
class AnPopupCupom extends HTMLElement {
  log(msg) {
    // console para o desktop; sessionStorage para ler no celular apos recarga
    console.debug('[popup] ' + msg);
    try {
      const l = JSON.parse(sessionStorage.getItem('an-popup-log') || '[]');
      l.push(new Date().toISOString().slice(11, 19) + ' ' + msg);
      sessionStorage.setItem('an-popup-log', JSON.stringify(l.slice(-20)));
    } catch (e) {}
  }

  connectedCallback() {
    this.log('script v3 iniciou; url=' + location.pathname + location.search);
    if (location.search.includes('popupdebug=1')) {
      try { alert('LOG DO POPUP\n\n' + JSON.parse(sessionStorage.getItem('an-popup-log') || '[]').join('\n')); } catch (e) {}
    }

    // O ModalDialog do Dawn se move para o <body> ao conectar. Se ele ja
    // se moveu, nao esta mais dentro deste elemento — por isso a busca pelo id.
    this.dialog = document.getElementById(this.dataset.dialog) || this.querySelector('modal-dialog');
    if (!this.dialog) return;

    this.bolha = this.querySelector('[data-bolha-el]');
    const sucesso = !!this.dialog.querySelector('[data-an-inscrito-ok]');
    const atraso = Math.max(0, parseInt(this.dataset.atraso || '6', 10)) * 1000;
    this.diasFechado = Math.max(1, parseInt(this.dataset.dias || '7', 10));
    this.diasBolha = Math.max(1, parseInt(this.dataset.bolhaDias || '3', 10));

    this.ligarCopiar();
    this.ligarFechar();
    this.ligarBolha();
    this.ligarEnvio();

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:select', (e) => { if (e.target.contains(this)) this.abrir(); });
      document.addEventListener('shopify:section:deselect', (e) => { if (e.target.contains(this)) this.dialog.hide(); });
      this.mostrarBolha();
      return;
    }

    if (/\/(cart|checkout|checkouts|account|challenge)\b/.test(location.pathname)) return;

    if (sucesso) {
      // Recarga apos o envio normal (caminho do desafio anti-robo). A secao
      // de newsletter da home tambem ve customer_posted=true e da autofocus
      // na propria mensagem de sucesso, rolando a pagina ate ela. Desfaz o
      // foco e volta ao topo antes de abrir o popup.
      if (document.activeElement && document.activeElement !== document.body) document.activeElement.blur();
      window.scrollTo(0, 0);
      this.abrir();
      this.lembrar('inscrito', 365);
      this.limparUrl();
      return;
    }

    if (this.lembrado('inscrito')) return;

    // fechou o popup: grava e mostra a bolha.
    // O hide() do Dawn dispara 'modalClosed' ANTES de remover o atributo
    // 'open', entao a checagem precisa esperar um tick. E 'modalClosed' e
    // generico (o guia de medidas tambem e um modal-dialog), por isso so reage
    // se foi ESTE popup que esteve aberto.
    document.body.addEventListener('modalClosed', () => {
      setTimeout(() => {
        if (!this.estavaAberto) return;
        if (this.dialog.hasAttribute('open')) return;
        this.estavaAberto = false;
        if (this.lembrado('inscrito')) return;
        this.lembrar('fechado', this.diasFechado);
        this.mostrarBolha();
      }, 0);
    });

    if (this.lembrado('fechado')) {
      this.mostrarBolha();
      return;
    }

    setTimeout(() => this.abrir(), atraso);
  }

  abrir() {
    this.esconderBolha();
    this.estavaAberto = true;
    this.dialog.show(document.activeElement);
  }

  /* ---- bolha ---- */
  ligarBolha() {
    if (!this.bolha) return;
    const abrir = this.bolha.querySelector('[data-bolha-abrir]');
    const fechar = this.bolha.querySelector('[data-bolha-fechar]');
    if (abrir) abrir.addEventListener('click', () => this.abrir());
    if (fechar) fechar.addEventListener('click', (e) => {
      e.stopPropagation();
      this.lembrar('bolha', this.diasBolha);
      this.esconderBolha();
    });
  }

  mostrarBolha() {
    if (!this.bolha) return;
    if (this.lembrado('bolha') && !(window.Shopify && window.Shopify.designMode)) return;
    this.bolha.hidden = false;
  }

  esconderBolha() {
    if (this.bolha) this.bolha.hidden = true;
  }

  /* ---- envio sem recarregar ---- */
  ligarEnvio() {
    const form = this.dialog.querySelector('form');
    if (!form) return;

    // A Shopify gera action="/contact#AnPopupCupomForm". Esse '#' e o que
    // faz a pagina rolar ate a ancora depois de um envio normal. Sem ele,
    // ate o plano B volta para o topo da pagina, limpo.
    form.action = form.action.split('#')[0];

    // O <script id="captcha-bootstrap"> da Shopify intercepta todo formulario
    // que case com form[action*='/contact'] + form_type=customer e chama
    // form.submit() por conta propria, ignorando o preventDefault. Isso
    // derrubava o envio por AJAX e recarregava a pagina. O proprio seletor
    // dele exclui :not([data-nocaptcha='true']) — e a porta de saida oficial.
    form.setAttribute('data-nocaptcha', 'true');

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      this.log('submit interceptado');
      const botao = form.querySelector('[data-an-enviar]');
      const erro = form.querySelector('[data-an-erro]');
      if (botao) botao.disabled = true;
      if (erro) erro.hidden = true;

      try {
        const res = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          redirect: 'follow',
          credentials: 'same-origin',
          headers: { Accept: 'text/html' },
        });
        const html = await res.text();
        this.log('resposta ' + res.status + ' ' + res.url);

        // Sucesso primeiro: o servidor so renderiza este marcador quando
        // posted_successfully? e verdadeiro. Nome unico, nao e substring de
        // nada que exista na pagina normal.
        if (res.ok && (html.includes('data-an-inscrito-ok') || res.url.includes('customer_posted=true'))) {
          this.mostrarSucesso();
          return;
        }

        // Verificacao anti-robo da Shopify ("Um momento..."): so resolve em
        // pagina cheia. NAO procurar 'recaptcha'/'hcaptcha': a Shopify injeta
        // esses scripts em toda pagina e daria falso positivo no sucesso.
        // Cloudflare (__cf_chl) ou verificacao da Shopify (/challenge). A da
        // Cloudflare e por reputacao de IP e dispara depois de muitos envios
        // de teste; nao tem configuracao para desligar.
        const desafio = res.url.includes('/challenge')
          || res.url.includes('__cf_chl')
          || /action="\/challenge"/i.test(html)
          || /cf-challenge|__cf_chl|needs to be verified|precisa ser verificada/i.test(html);
        if (desafio) {
          this.log('desafio anti-robo, enviando normal');
          form.submit();
          return;
        }

        this.log('sem sucesso na resposta');
        if (erro) { erro.textContent = 'Não deu certo. Confira o e-mail e tente de novo.'; erro.hidden = false; }
        if (botao) botao.disabled = false;
      } catch (err) {
        this.log('fetch falhou: ' + (err && err.message));
        form.submit();
      }
    });
  }

  mostrarSucesso() {
    this.log('sucesso: trocando estado sem recarregar');
    const convite = this.dialog.querySelector('[data-an-convite]');
    const sucesso = this.dialog.querySelector('[data-an-sucesso-bloco]');
    if (convite) convite.hidden = true;
    if (sucesso) {
      sucesso.hidden = false;
      const frase = sucesso.querySelector('.an-popup__frase');
      if (frase) { frase.setAttribute('tabindex', '-1'); frase.focus(); }
    }
    this.lembrar('inscrito', 365);
    this.esconderBolha();
  }

  /* ---- fechar / copiar ---- */
  ligarFechar() {
    this.dialog.querySelectorAll('[data-fechar]').forEach((el) => {
      el.addEventListener('click', (e) => {
        if (el.tagName === 'BUTTON') e.preventDefault();
        this.dialog.hide();
      });
    });
  }

  ligarCopiar() {
    const codigo = this.dialog.querySelector('[data-copiar]');
    const status = this.dialog.querySelector('[data-copiar-status]');
    if (!codigo) return;
    const original = status ? status.textContent : '';
    codigo.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(codigo.dataset.copiar);
        if (status) status.textContent = 'Copiado!';
        setTimeout(() => { if (status) status.textContent = original; }, 2200);
      } catch (e) {
        const r = document.createRange(); r.selectNodeContents(codigo);
        const sel = getSelection(); sel.removeAllRanges(); sel.addRange(r);
      }
    });
  }

  /* ---- memoria ---- */
  chave(nome) { return 'an-popup-cupom:' + nome; }

  lembrado(nome) {
    try { return parseInt(localStorage.getItem(this.chave(nome)) || '0', 10) > Date.now(); }
    catch (e) { return false; }
  }

  lembrar(nome, dias) {
    try { localStorage.setItem(this.chave(nome), String(Date.now() + dias * 864e5)); }
    catch (e) { /* modo privado */ }
  }

  limparUrl() {
    if (location.search.includes('customer_posted')) {
      history.replaceState(null, '', location.pathname + location.hash);
    }
  }
}
customElements.define('an-popup-cupom', AnPopupCupom);
